import { breakpoints } from '../config/breakpoints';

export function widgetOpen(el) {
  el.classList.add('open');
  document.querySelector('.header').classList.add('widget-open');
}

export function widgetClose(el) {
  el.classList.remove('open');

  if (!el.classList.contains('js-control-container')) {
    document.querySelector('.header')?.classList.remove('widget-open');
  }
}

export function controlOpen(el) {
  const container = el.querySelector('.js-control-container');
  container.classList.add('open');
}

export function controlClose(el) {
  const container = el.querySelector('.js-control-container');
  container.classList.remove('open');
}

export function controlCloseAll(el) {
  const containers = el.querySelectorAll('.js-control-container');
  containers.forEach((container) => {
    container.classList.remove('open');
  });
}

export function backdropAdd() {
  window.document.body.classList.add('backdrop');
}

export function backdropRemove() {
  window.document.body.classList.remove('backdrop');
}

export function focusOn(el) {
  el.focus();
}

export function closeAll(elements) {
  elements.forEach((element) => {
    element.classList.remove('open');
  });
}

export const isMobile = () => window.innerWidth < breakpoints.md;

let scrollPosition = 0;
const bodyStyle = document.body.style;
export const isAndroid = /Android/.test(navigator.userAgent);
export const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);

export function fixedBodyStyleAddAll() {
  scrollPosition = window.pageYOffset || document.documentElement.scrollTop;

  if (isAndroid) {
    bodyStyle.setProperty('overflow', 'hidden', 'important');
    bodyStyle.setProperty('position', 'relative', 'important');
    bodyStyle.setProperty('height', '100vh', 'important');
    return;
  }

  bodyStyle.setProperty('position', 'fixed', 'important');
  bodyStyle.setProperty('overflow', 'hidden', 'important');
  bodyStyle.setProperty('width', '100%', 'important');
  bodyStyle.setProperty('height', '100%', 'important');
  bodyStyle.setProperty('top', `-${scrollPosition}px`, 'important');
  bodyStyle.setProperty('-webkit-overflow-scrolling', 'touch', 'important');
  bodyStyle.setProperty('touch-action', 'none', 'important');
  bodyStyle.setProperty('-ms-touch-action', 'none', 'important');
}

export function fixedBodyStyleRemoveAll() {
  const currentPosition = bodyStyle.getPropertyValue('position');

  if (isAndroid && currentPosition === 'relative') {
    bodyStyle.removeProperty('position');
    bodyStyle.removeProperty('overflow');
    bodyStyle.removeProperty('height');
    window.scrollTo({
      top: scrollPosition,
      left: 0,
      behavior: 'instant',
    });
    return;
  }

  if (currentPosition === 'fixed') {
    bodyStyle.removeProperty('position');
    bodyStyle.removeProperty('overflow');
    bodyStyle.removeProperty('width');
    bodyStyle.removeProperty('height');
    bodyStyle.removeProperty('top');
    bodyStyle.removeProperty('-webkit-overflow-scrolling');
    bodyStyle.removeProperty('touch-action');
    bodyStyle.removeProperty('-ms-touch-action');

    window.scrollTo({
      top: scrollPosition,
      left: 0,
      behavior: 'instant',
    });

    if (window.pageYOffset !== scrollPosition) {
      document.documentElement.style.scrollBehavior = 'auto';
      window.scrollTo(0, scrollPosition);

      requestAnimationFrame(() => {
        document.documentElement.style.scrollBehavior = 'smooth';
      });
    }
  }
}

export function isBodyFixed() {
  return bodyStyle.getPropertyValue('position') === 'fixed';
}

export function updateCatalogOverflowState(context, containerSelector = '.js-control-container') {
  const scope = context || window.document;
  const openContainer = scope.querySelector(`${containerSelector}.open`);
  if (!openContainer) return;

  const list = openContainer.querySelector('.c-destination__catalog-container');
  if (!list) return;

  requestAnimationFrame(() => {
    const catalogHasOverflow = list.scrollHeight > list.clientHeight + 1;
    list.classList.toggle('no-scroll', !catalogHasOverflow);

    if (isMobile()) {
      const containerHasOverflow = openContainer.scrollHeight > openContainer.clientHeight + 1;
      openContainer.classList.toggle('no-scroll', !containerHasOverflow);
    }
  });
}

export function findNextControlTrigger(control) {
  if (!control) {
    return null;
  }

  const trigger = control.querySelector('.js-control-trigger');
  const widget = control.closest('.js-booking-widget');
  if (!trigger || !widget) {
    return null;
  }

  const triggers = Array.from(widget.querySelectorAll('.js-control-trigger'));
  const currentIndex = triggers.indexOf(trigger);
  if (currentIndex === -1) {
    return null;
  }

  return triggers.slice(currentIndex + 1).find((element) => element) ?? null;
}

export function focusNextControlTrigger(control) {
  const nextTrigger = findNextControlTrigger(control);
  if (nextTrigger) {
    nextTrigger.focus();
  }
}
